<template>
    <button :class="class_" @click="clickButton" :disabled='loading'>
        <span v-show="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span v-if="type_=='loading'" v-show="!loading">{{text}}</span>
        <i v-if="type_=='download'" v-show="!loading" class="demo-icon mm-icon-download" />
    </button>
</template>

<script>
    export default {
        name: 'mmButton',
        props: {
                type: String,
                classe: String,
                text: String,
                click:{type:Function}},
        data() {
            return {
                class_ : 'btn btn-primary',
                type_ : 'loading',
                loading : false
            }
        },
        created() {
            if(this.type != undefined) {
                this.type_ = this.type;
            }
            
            if(this.classe !== undefined) {
                this.class_ = this.classe;
            }
        },
        methods: {
            async clickButton() {
                this.loading = true;
                await this.click();
                setTimeout(()=> {this.loading = false}, 300);
            }
        }
    }
</script>